import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { Content, DraggableHandler, ExtendedWrapper } from './Draggable.styles';

interface Props {
  children: React.ReactNode;
  expanded: number;
}

export const Draggable = ({ children, expanded }: Props) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: 'draggable',
  });

  const xPosition = transform?.x ?? 0;

  const newWidth = expanded + xPosition;

  return (
    <Content>
      <ExtendedWrapper
        style={{
          width: `${newWidth}px`,
        }}
      >
        {children}
      </ExtendedWrapper>

      <DraggableHandler ref={setNodeRef} {...attributes} {...listeners} isDragging={isDragging} />
    </Content>
  );
};
